module.exports = __webpack_public_path__ + "static/img/tabs2.286ee61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabs2.png
// module id = ifvM
// module chunks = 13